import { render, staticRenderFns } from "./CustomerAddressTax.vue?vue&type=template&id=874d4e22&scoped=true"
import script from "./CustomerAddressTax.vue?vue&type=script&lang=js"
export * from "./CustomerAddressTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874d4e22",
  null
  
)

export default component.exports